import type { CountryConfigMap } from '../auth-config-types'

/**
 * North America Entra External ID (GMCIAMTEST) — parallel to B2C in preproduction.config.ts.
 * `mapAuthority` is the CIAM tenant root (no trailing `/v2.0`); MSAL appends `/v2.0` for OIDC metadata. `mapPolicy` unused for Entra.
 * US Entra preprod `339df9b4-9230-4d65-b4cc-f4ee5759a1b3`. Canada `05fa496b-3823-48cb-ab21-1556e80e7ffd`. Mexico `f882c7df-afd5-480c-8dc4-ef0886f1451b`.
 */
export const naEntraExternalIdPreproductionConfig: Pick<CountryConfigMap, 'US' | 'CA' | 'MX'> = {
	US: {
		en: {
			mapTenant: 'ciamlogin.pp.gm.com',
			mapAuthority: 'https://ciamlogin.pp.gm.com/1b84deee-7bd0-4f65-9659-6f620dcac84a',
			mapPolicy: '',
			mapClientId: '339df9b4-9230-4d65-b4cc-f4ee5759a1b3',
			mapAuthScopes: ['openid', 'profile'],
			mapApprovedAuthorities: ['ciamlogin.pp.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/',
			urls: {
				MyAccountProfileURL: '/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '/bypass/apim/global-nav/loyalty/points',
				rewardsUseLoyaltyHeaders: true,
				MyAccountVehicleURL: '/ownercenter/api/garagesummary',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '/notif/delivery/inbox/v1/customer',
				logoutURL: location.origin,
			},
		},
	},
	CA: {
		en: {
			mapTenant: 'ciamlogin.pp.gm.com',
			mapAuthority: 'https://ciamlogin.pp.gm.com/1b84deee-7bd0-4f65-9659-6f620dcac84a',
			mapPolicy: '',
			mapClientId: '05fa496b-3823-48cb-ab21-1556e80e7ffd',
			mapAuthScopes: ['openid', 'profile'],
			mapApprovedAuthorities: ['ciamlogin.pp.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/en',
			urls: {
				MyAccountProfileURL: '/en/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '/en/ownercenter/api/garagesummary',
				MyAccountMissingInfoURL: '/en/ownercenter/api/checkMissingInfo',
				NotificationInboxURL: '/en/notif/delivery/inbox/v1/customer',
				logoutURL: location.origin + '/en',
			},
		},
		fr: {
			mapTenant: 'ciamlogin.pp.gm.com',
			mapAuthority: 'https://ciamlogin.pp.gm.com/1b84deee-7bd0-4f65-9659-6f620dcac84a',
			mapPolicy: '',
			mapClientId: '05fa496b-3823-48cb-ab21-1556e80e7ffd',
			mapAuthScopes: ['openid', 'profile'],
			mapApprovedAuthorities: ['ciamlogin.pp.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/fr',
			urls: {
				MyAccountProfileURL: '/fr/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '/fr/ownercenter/api/garagesummary',
				MyAccountMissingInfoURL: '/fr/ownercenter/api/checkMissingInfo',
				NotificationInboxURL: '/fr/notif/delivery/inbox/v1/customer',
				logoutURL: location.origin + '/fr',
			},
		},
	},
	MX: {
		es: {
			mapTenant: 'ciamlogin.pp.gm.com',
			mapAuthority: 'https://ciamlogin.pp.gm.com/1b84deee-7bd0-4f65-9659-6f620dcac84a',
			mapPolicy: '',
			mapClientId: 'f882c7df-afd5-480c-8dc4-ef0886f1451b',
			mapAuthScopes: ['openid', 'profile'],
			mapApprovedAuthorities: ['ciamlogin.pp.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/',
			urls: {
				MyAccountProfileURL: '/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin,
			},
		},
	},
}
